import Konva from "konva";
import React, { MutableRefObject } from "react";
import ReactQuill from "react-quill";
import CircleShape from "../Circle";
import ImageRichText from "../ImageRichText";
import Rectangle from "../Rectangle";
import SimpleLine from "../SimpleLine";
import SimpleText from "../SimpleText";
import StarIcon from "../Star";
import SvgElement from "../SvgShape";
import TriangleNew from "../TriangleNew";
import URLImage from "../URLimage";
import URLImageDrag from "../URLImageDrag";
import * as QuillText from "quill";

interface SelectionProps {
  index: number;
  length: number;
}

interface RenderingProps {
  objectProps: {
    id: string;
    object: string;
    x: number;
    y: number;
    src?: string;
    width?: number;
    height?: number;
    fill?: string;
    text?: string;
    fontSize?: number;
    setPoints?: number;
  };
  setSelectedObject?: React.Dispatch<React.SetStateAction<Konva.Shape>>;
  selectedObject?: Konva.Shape;
  addToHistory?: (isLastHistory?: boolean) => void;
  onChange?: any;
  currentMultipleSelection?: React.MutableRefObject<Konva.Transformer>;
  setObjectScreen?: React.Dispatch<React.SetStateAction<PagesProps[]>>;
  commandKeyboard?: boolean;
  setCommandBlockKeyboard?: React.Dispatch<React.SetStateAction<boolean>>;
  transformerSelectedObject?: React.MutableRefObject<Konva.Transformer | null>;
  quillRef?: MutableRefObject<ReactQuill>;
  requestUpdateText?: () => void;
  textRich?: MutableRefObject<string>;
  isEditing?: "closed" | "blocked" | "open";
  setIsEditing?: React.Dispatch<
    React.SetStateAction<"closed" | "blocked" | "open">
  >;
  blockingKeyboard?: boolean;
  setBlockingKeyboard?: React.Dispatch<React.SetStateAction<boolean>>;
  templateStartedShared?: boolean;
  setTemplateStartedShared?: React.Dispatch<React.SetStateAction<boolean>>;
  oldContentsState?: null | QuillText.DeltaStatic;
  setOldContentsState?: null | React.Dispatch<
    React.SetStateAction<QuillText.DeltaStatic>
  >;
  newContentsState?: null | QuillText.DeltaStatic;
  setNewContentsState?: null | React.Dispatch<
    React.SetStateAction<QuillText.DeltaStatic>
  >;
  selectionCursor?: SelectionProps;
  setSelectionCursor?: React.Dispatch<React.SetStateAction<SelectionProps>>;
  findDiff?: () => void;
  buttonRef?: React.MutableRefObject<HTMLButtonElement>;
  isEditingQuill?: boolean;
  setIsEditingQuill?: React.Dispatch<React.SetStateAction<boolean>>;
  newDelta?: null | QuillText.DeltaStatic;
  newChanges?: string;
  setNewChanges?: React.Dispatch<React.SetStateAction<string>>;
  setNewDelta?: React.Dispatch<React.SetStateAction<QuillText.DeltaStatic>>;
  oldContentsRef?: null | React.MutableRefObject<QuillText.DeltaStatic>;
  newContentsRef?: null | React.MutableRefObject<QuillText.DeltaStatic>;
  getQuillCursorRef?: null | React.MutableRefObject<SelectionProps>;
  isNewTextRef?: React.MutableRefObject<boolean>;
  isTypingQuillRef?: React.MutableRefObject<boolean>;
  quillRefComponent?: React.MutableRefObject<ReactQuill>;
  whichUserEdited?: React.MutableRefObject<string>;
  nameOfCurrentUser?: React.MutableRefObject<string>;
  interceptModifications?: React.MutableRefObject<boolean>;
  textIsChanged?: React.MutableRefObject<boolean>;
  blockRenderImage?: React.MutableRefObject<boolean>;
  blockBackspace?: React.MutableRefObject<boolean>;
  hasGroupShared?: React.MutableRefObject<boolean>;
  whichKeyPress?: React.MutableRefObject<string>;
  selectionFormatText?: React.MutableRefObject<QuillText.StringMap>;
  isClickLineMultiSelection?: boolean;
  setIsClickLineMultiSelection?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IRenderedObject {
  x: number;
  y: number;
  width: number;
  align?: "justify" | "center" | "left" | "right";
  text?: string;
  fontSize?: number;
  fontFamily?: string;
  fill?: string;
  id: string;
  object: string;
  setPoints?: number;
  stroke?: string;
  strokeWidth?: string;
  src?: string;
  dash?: number[];
}
interface PagesProps {
  pageNumber: number;
  renderObjects: IRenderedObject[];
}

export default function Rendering({
  objectProps,
  setSelectedObject,
  selectedObject,
  addToHistory,
  currentMultipleSelection,
  setObjectScreen,
  commandKeyboard,
  setCommandBlockKeyboard,
  transformerSelectedObject,
  quillRef,
  requestUpdateText,
  textRich,
  isEditing,
  setIsEditing,
  blockingKeyboard,
  setBlockingKeyboard,
  templateStartedShared,
  setTemplateStartedShared,
  oldContentsState,
  setOldContentsState,
  newContentsState,
  setNewContentsState,
  selectionCursor,
  setSelectionCursor,
  findDiff,
  buttonRef,
  newDelta,
  setNewDelta,
  isEditingQuill,
  setIsEditingQuill,
  newChanges,
  setNewChanges,
  newContentsRef,
  oldContentsRef,
  getQuillCursorRef,
  isNewTextRef,
  isTypingQuillRef,
  quillRefComponent,
  whichUserEdited,
  nameOfCurrentUser,
  interceptModifications,
  textIsChanged,
  blockRenderImage,
  blockBackspace,
  hasGroupShared,
  whichKeyPress,
  selectionFormatText,
  isClickLineMultiSelection,
  setIsClickLineMultiSelection
}: RenderingProps) {
  let RenderObject = null;

  switch (objectProps.object) {
    case "image":
      RenderObject = (
        <URLImage
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );
      break;
    case "circle":
      RenderObject = (
        <CircleShape
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "rectangle":
      RenderObject = (
        <Rectangle
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "square":
      RenderObject = (
        <Rectangle
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "simpleLine":
      RenderObject = (
        <SimpleLine
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "simpleText":
      RenderObject = (
        <SimpleText
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          commandKeyboard={commandKeyboard}
          setCommandBlockKeyboard={setCommandBlockKeyboard}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
          onChange={newAttrs => {
            console.log(newAttrs, "");
          }}
        />
      );

      break;

    case "dropImage":
      RenderObject = (
        <URLImageDrag
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "richTextImage":
      RenderObject = (
        <ImageRichText
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
          quillRef={quillRef}
          requestUpdateText={requestUpdateText}
          textRich={textRich}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          blockingKeyboard={commandKeyboard}
          setBlockingKeyboard={setCommandBlockKeyboard}
          templateStartedShared={templateStartedShared}
          setTemplateStartedShared={setTemplateStartedShared}
          oldContentsState={oldContentsState}
          setOldContentsState={setOldContentsState}
          newContentsState={newContentsState}
          setNewContentsState={setNewContentsState}
          selectionCursor={selectionCursor}
          setSelectionCursor={setSelectionCursor}
          findDiff={findDiff}
          buttonRef={buttonRef}
          newDelta={newDelta}
          setNewDelta={setNewDelta}
          isEditingQuill={isEditingQuill}
          setIsEditingQuill={setIsEditingQuill}
          newChanges={newChanges}
          setNewChanges={setNewChanges}
          oldContentsRef={oldContentsRef}
          newContentsRef={newContentsRef}
          getQuillCursorRef={getQuillCursorRef}
          isNewTextRef={isNewTextRef}
          isTypingQuillRef={isTypingQuillRef}
          quillRefComponent={quillRefComponent}
          whichUserEdited={whichUserEdited}
          nameOfCurrentUser={nameOfCurrentUser}
          interceptModifications={interceptModifications}
          textIsChanged={textIsChanged}
          blockRenderImage={blockRenderImage}
          blockBackspace={blockBackspace}
          hasGroupShared={hasGroupShared}
          whichKeyPress={whichKeyPress}
          selectionFormatText={selectionFormatText}
        />
      );

      break;

    case "star":
      RenderObject = (
        <StarIcon
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "triangle2":
      RenderObject = (
        <TriangleNew
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );

      break;

    case "text":
      RenderObject = (
        <SimpleText
          shapeProps={objectProps}
          setObjectScreen={setObjectScreen}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          commandKeyboard={commandKeyboard}
          setCommandBlockKeyboard={setCommandBlockKeyboard}
          currentMultipleSelection={currentMultipleSelection}
          transformerSelectedObject={transformerSelectedObject}
          onChange={newAttrs => {}}
        />
      );

      break;

    case "icon":
      RenderObject = (
        <SvgElement
          shapeProps={objectProps}
          selectedObject={selectedObject}
          setSelectedObject={setSelectedObject}
          addToHistory={addToHistory}
          currentMultipleSelection={currentMultipleSelection}
          setObjectScreen={setObjectScreen}
          transformerSelectedObject={transformerSelectedObject}
        />
      );
      break;

    default:
      RenderObject = null;
      break;
  }

  return <>{RenderObject && RenderObject}</>;
}
